/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway.scss';

import gatewayFieldsetTemplate from './gateway-fieldset.tpl.html';
import spectrumAnalyzerDialogTemplate from './spectrum-analyzer/spectrum-analyzer.dialog.tpl.html';
import spectralScanDialogTemplate from './spectral-scan/spectral-scan.dialog.tpl.html';
import radioStatisticsDialogTemplate from './radio-statistics/radio-statistics.dialog.tpl.html';
import gatewayInfoDialogTemplate from './gateway-info/gateway-info.dialog.tpl.html';
import wmFirmwareTemplate from './wm-firmware/wm-firmware.dialog.tpl.html';

/* eslint-disable import/no-unresolved, import/default */

/* eslint-enable import/no-unresolved, import/default */

const defaultMapZoom = 12;
const dashboardTabIndex = 3;

/*@ngInject*/
export default function GatewayDirective($rootScope, $compile, $templateCache, $translate, $filter, $mdMedia, $mdDialog, toast, $sce, $window,
                                         $document, types, gatewayService, gatewayModelService, gatewayCommandService, grafanaService, $timeout) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayFieldsetTemplate);
        var rebootTime = 120000;
        element.html(template);

        scope.types = types;

        scope.fileTransferOption = types.fileTransferOptions.fileUpload.value;

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
        });

        scope.isGatewayRebooting = false;

        scope.gatewayCommand = {
            command: null,
            params: {},
            commandOutput: ''
        };

        scope.commandOutputOptions = {
            useWrapMode: false,
            mode: 'json',
            showGutter: false,
            showPrintMargin: false,
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            }
        };

        scope.poolGatewayLocation = false;

        scope.grafanaEnabled = $window.DynamicConfigs.grafanaEnabled === 'true';
        scope.grafanaIframeUrl = null;
        scope.creatingDashboard = false;

        scope.$watch('gateway.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    startGatewayLocationPooling();
                    createGatewaySubscriptions();
                    if (scope.grafanaEnabled && scope.selectedTab == dashboardTabIndex) {
                        createGrafanaDashboard();
                    }
                }
            }
        });

        scope.$watch('selectedTab', (newVal, prevVal) => {
            if (newVal !== prevVal && scope.grafanaEnabled && newVal === dashboardTabIndex &&
                scope.gateway.id && !scope.grafanaIframeUrl) {
                createGrafanaDashboard();
            }
        })

        scope.$watch('gateway.gatewayModelId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                loadGatewayFrequencyInfo();
            }
        });

        scope.$watch('gatewayCommand.command', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                scope.gatewayCommand.params = {};
                scope.gatewayCommand.commandOutput = '';
                if (scope.gatewayCommand.command == types.gatewayCommand.reverseSsh.value) {
                    scope.gatewayCommand.params.options = '-f -N -T -R';
                }
        }
        });

        scope.onGatewayIdCopied = function() {
            toast.showSuccess($translate.instant('gateway.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.openSpectrumAnalyzer = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectrumAnalyzerController',
                controllerAs: 'vm',
                templateUrl: spectrumAnalyzerDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openSpectralScan = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectralScanController',
                controllerAs: 'vm',
                templateUrl: spectralScanDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openRadioStatistics = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'RadioStatisticsController',
                controllerAs: 'vm',
                templateUrl: radioStatisticsDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openGatewayInfo = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'GatewayInfoController',
                controllerAs: 'vm',
                templateUrl: gatewayInfoDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openWmFirmwareDialog = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'WmFirmwareController',
                controllerAs: 'vm',
                templateUrl: wmFirmwareTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.toggleGatewayState = function() {
            var promise = scope.gateway.disabled ? gatewayService.enableGateway(scope.gateway.id.id)
                : gatewayService.disableGateway(scope.gateway.id.id);
            promise.then(
                () => {
                    scope.gateway.disabled = !scope.gateway.disabled;
                    updateGatewayStateParameters();
                    $rootScope.$broadcast('reloadEntityDetails');
                    $rootScope.$broadcast('entityUpdated', scope.gateway);
                }
            );
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 1) {
                    scope.selectedTab = 0;
                }
                updateGatewayLocation();
            }
        });

        scope.$on("$destroy", function () {
            reset();
        });

        scope.executeGatewayCommand = function () {
            gatewayCommandService.executeCommand(scope.gateway.id.id,
                scope.gatewayCommand.command, scope.gatewayCommand.params).then(
                    (commandResult) => {
                        if (scope.gatewayCommand.command === types.gatewayCommand.reboot.value) {
                            checkIfGatewayIsRebooted(commandResult);
                        }

                        if (commandResult) {
                            if (commandResult.output) {
                                scope.gatewayCommand.commandOutput = commandResult.output;
                            } else if (commandResult.error) {
                                if (angular.equals(commandResult.error, types.gatewayCommandNotSupported.value)) {
                                    var toastParent = angular.element(".tk-ace-command-output", $document);
                                    toast.showError($translate.instant("gateway-command.not-supported"), toastParent.closest(".toast-parent"), "bottom right");
                                    scope.gatewayCommand.commandOutput = $translate.instant("gateway-command.not-supported").toString();
                                }
                            } else {
                                scope.gatewayCommand.commandOutput = angular.toJson(commandResult, true)
                            }
                        } else {
                            scope.gatewayCommand.commandOutput = '';
                        }
                    },
                    (rejection) => {
                        scope.gatewayCommand.commandOutput = 'Error executing gateway command.';
                        if (rejection.status) {
                            scope.gatewayCommand.commandOutput += '\nStatus: ' + rejection.status;
                        }
                        if (rejection.data) {
                            scope.gatewayCommand.commandOutput += '\nError: ';
                            if (rejection.data.message) {
                                scope.gatewayCommand.commandOutput += rejection.data.message;
                            } else {
                                scope.gatewayCommand.commandOutput += rejection.data;
                            }
                        }
                    }
            );
        };

        function checkIfGatewayIsRebooted(commandResult) {
              if (commandResult === null) {
                toast.showSuccess($translate.instant('gateway.gateway-is-rebooting', { name: scope.gateway.name }));
                scope.isGatewayRebooting = true;
                $timeout(() => {
                    scope.isGatewayRebooting = false;
                    toast.showSuccess($translate.instant('gateway.gateway-has-been-successfully-rebooted', { name: scope.gateway.name }));
                }, rebootTime)
              } else {
                  toast.showError($translate.instant('gateway.can-not-reboot-gateway', { name: scope.gateway.name }))
              }
         }

        function startGatewayLocationPooling() {
            scope.poolGatewayLocation = true;
            updateGatewayLocation();
            poolGatewayLocation();
        }

        function poolGatewayLocation() {
            $timeout(() => {
                if (!scope.poolGatewayLocation) {
                    return;
                }
                updateGatewayLocation();

                poolGatewayLocation()
            }, rebootTime);
        }

        function loadGatewayFrequencyInfo() {
            scope.gatewayFrequencyBandInfo = null;
            if (scope.gateway.gatewayModelId) {
                gatewayModelService.getGatewayModel(scope.gateway.gatewayModelId.id).then(
                    (gatewayModel) => {
                        scope.gatewayFrequencyBandInfo = types.gatewayFrequency[gatewayModel.gatewayFrequency].info;
                        scope.gatewayModelChannels = gatewayModel.additionalInfo ? gatewayModel.additionalInfo.channels : '';
                    }
                );
            }
        }

        function updateGatewayStateParameters() {
            if (scope.gatewayState.online && !scope.gateway.disabled) {
                scope.onlineStatus = $translate.instant('gateway.online');
                scope.onlineStatusColor = '#1a901a';
            } else {
                scope.onlineStatus = scope.gateway.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.offline');
                scope.onlineStatusColor = '#ff0000';
            }
        }

        function reset() {

            scope.gatewayCommand.command = null;
            scope.gatewayCommand.params = {};
            scope.gatewayCommand.commandOutput = '';
            scope.isGatewayRebooting = false;

            scope.grafanaIframeUrl = null;

            scope.gatewayState = {};

            if (scope.gatewayStateSubscriptionHandle) {
                scope.gatewayStateSubscriptionHandle();
                scope.gatewayStateSubscriptionHandle = null;
            }
            scope.lastOnlineTime = null;

            updateGatewayStateParameters();

            scope.currentGatewayCenter = {
                lat: 0,
                lng: 0,
                zoom: 1
            };

            scope.markers = {};

            scope.poolGatewayLocation = false;
        }

        function createGatewaySubscriptions() {
            scope.gatewayStateSubscriptionHandle = gatewayService.subscribeForGatewayStateData(scope.gateway.id.id,
                onGatewayStateData);
        }

        function onGatewayStateData(gatewayState) {
            scope.$apply(() => {
                scope.gatewayState = gatewayState;
                if (scope.gatewayState.lastOnlineTime) {
                    scope.lastOnlineTime = $filter('date')(scope.gatewayState.lastOnlineTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastOnlineTime = null;
                }
                updateGatewayStateParameters();
            });
        }

        function updateGatewayLocation() {
            gatewayCommandService.executeCommand(scope.gateway.id.id,
                types.gatewayCommand.getGpsCoordinates.value, {}, true).then(
                (params) => {
                    var lat = null, lng = null, altitude = null;
                    if (params.status === "ok") {
                        lat = +params.lat;
                        lng = +params.long;
                        altitude = +params.alti;
                    }

                    if (lat && lng && altitude) {
                        scope.gateway.lat = lat;
                        scope.gateway.lng = lng;
                        scope.gateway.altitude = altitude;

                        scope.currentGatewayCenter.lat = scope.gateway.lat;
                        scope.currentGatewayCenter.lng = scope.gateway.lng;

                        if (!scope.markers.gateway) {
                            scope.currentGatewayCenter.zoom = defaultMapZoom;
                        }
                        scope.markers.gateway = {
                            lat: scope.gateway.lat,
                            lng: scope.gateway.lng
                        }
                    } else {
                        scope.currentGatewayCenter.lat = 0;
                        scope.currentGatewayCenter.lng = 0;
                        scope.currentGatewayCenter.zoom = 1;
                        delete scope.markers.gateway;
                    }
                },
                (rejection) => {
                    onError(rejection.data);
                }
            );
        }

        function onError(error) {
            var toastParent = angular.element('.tk-ace-command-output', $document);
            toast.showError(error, toastParent.closest(".toast-parent"), "bottom right");
        }

        function createGrafanaDashboard() {
            scope.creatingDashboard = true;
            grafanaService.createGatewayDashboard(scope.gateway.id.id).then(function (response) {
                scope.creatingDashboard = false;
                if (response && response.accessToken) {
                    const url = 'https://' + $window.DynamicConfigs.appHost + '/grafana/public-dashboards/' + response.accessToken;
                    scope.grafanaIframeUrl = $sce.trustAsResourceUrl(url);
                } else {
                    toast.showError('Failed to create dashboard', 3000);
                }
            }).catch(function () {
                scope.creatingDashboard = false;
                toast.showError('Failed to create dashboard', 3000);
            });
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gateway: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway.directive.js